__turbopack_context__.v({
  "label": "TryToSearch-module-scss-module__Ou_ZuG__label",
  "list": "TryToSearch-module-scss-module__Ou_ZuG__list",
  "root": "TryToSearch-module-scss-module__Ou_ZuG__root",
  "suggestionButton": "TryToSearch-module-scss-module__Ou_ZuG__suggestionButton",
});
